export const SUBMIT_BUTTON_FIELD_STYLE = {
  margin: 0,
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
};
